export default "__VITE_ASSET__CGaEvWbw__"